import React from 'react';
import config from '../../../config'
// import shadesOfGrey from './mapStyles/shades-of-grey.json';
import { StyledMap } from './styled';


class Map extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const {disabled} = this.props;
    if (!disabled) {
      this._preloadMap();
    }
  }

  _preloadMap() {
    if (window && window.google) {
      this._initMap();
    } else {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${config.google.mapsKey}`;
      script.async = true;
      document.body.appendChild(script);
      this._waitForMapsScript();
    }
  };

  _waitForMapsScript() {
    this._t = setTimeout(() => {
      if (window && window.google) {
        this._initMap();
      } else {
        this._waitForMapsScript();
      }
    }, 100);
  };

  _initMap() {


    const {coordinates,zoom} = this.props;
    if (!coordinates) {
      return;
    }
    const lat = parseFloat(coordinates.split(', ')[0]);
    const lng = parseFloat(coordinates.split(', ')[1]);

    const cavr = {lat: lat, lng: lng};
    const options = {
      zoom: zoom?zoom:15,
      center: cavr,
      // styles: shadesOfGrey.style,
      disableDefaultUI: true,
      scrollwheel: false,
      zoomControl: true
    };

    const mapElement = document.getElementById('map');
    const map = new google.maps.Map(mapElement, options);
    const pin = {
      url: require('!!url-loader!./pin.png'),
      size: new google.maps.Size(48, 48),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(24, 24),
      scaledSize: new google.maps.Size(24, 24)
    };
    const marker = new google.maps.Marker({
      position: cavr,
      map: map,
      icon: pin
    });
  };

  render() {
    const {disabled, className} = this.props;
   
    return (
      <StyledMap width={this.props.width?this.props.width:'100%'} height={this.props.height?this.props.height:'100%'}>
        {
          !disabled && <div id="map" />
        }
      </StyledMap>
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/elements/GoogleMap/GoogleMap.jsx